<template>
  <roe-chart-table-switch
    name="Lag Indicators show potential impact on account balances at retirement"
  >
    <template #chartView>
      <roe-line-chart :values="balanceValues()"></roe-line-chart>

      <div class="table table-chart">
        <div class="table-row">
          <div class="table-unit table-desc-unit"></div>
          <div class="table-unit" v-for="(design, index) in designs">
            <h4>{{ design.account_balance | currency }}</h4>
            <template v-if="index !== 0">
              <span class="main-label">{{
                designDifference(design) | currency | plus
              }}</span>
              <div class="light-label">
                {{ designDifferenceInPercent(design) | percentage | plus }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>

    <template #tableView>
      <div class="table-row">
        <div class="table-unit table-desc-unit">
          Impact
        </div>
        <div class="table-unit" v-for="design in designs">
          {{ design.account_balance | currency }}
        </div>
      </div>
      <div class="table-row">
        <div class="table-unit table-desc-unit">
          Difference
        </div>
        <div class="table-unit" v-for="(design, index) in designs">
          <template v-if="index !== 0">
            {{ designDifference(design) | currency | plus }}
            <div class="common-light-label">
              {{ designDifferenceInPercent(design) | percentage | plus }}
            </div>
          </template>
        </div>
      </div>
    </template>
  </roe-chart-table-switch>
</template>

<script>
import { mapGetters } from "vuex";
import RoeLineChart from "@/components/charts/LineChart";
import RoeChartTableSwitch from "@/components/alternative-designs/_shared/ChartTableSwitch";

export default {
  name: "RoeLagIndicatorsBalanceImpact",
  components: { RoeChartTableSwitch, RoeLineChart },
  computed: {
    ...mapGetters(["designs", "originalDesign"])
  },
  methods: {
    designDifference(design) {
      return design.account_balance - this.originalDesign.account_balance;
    },
    designDifferenceInPercent(design) {
      return (
        this.designDifference(design) / this.originalDesign.account_balance
      );
    },
    balanceValues() {
      return this.designs.map(v => +v.account_balance);
    }
  }
};
</script>
